"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useConditionalLogic = _interopRequireDefault(require("./useConditionalLogic"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Ermöglicht das toggeln von Optionen innerhalb eines Select.
 * Kann aber auch mit anderen Elementen die Choices entgegennehmen verwendet werden.
 *
 * @param {object} choices Objekt der entsprechenden Choices eines Select.
 * @param {string|string[]} toggleKeys Keys der Optionen die getoggelt werden.
 * @param {array} rules @see ./useConditionalLogic
 * @param {object} options @see ./useConditionalLogic
 * @returns {object}
 */
var useConditionalChoices = function useConditionalChoices(choices, toggleKeys, rules, options) {
  var conditionIsValid = (0, _useConditionalLogic.default)(rules, options);
  if (!conditionIsValid) return choices;
  return Object.keys(choices).filter(function (key) {
    if (typeof toggleKeys === 'string') {
      return toggleKeys !== key;
    }
    return !toggleKeys.includes(key);
  }).reduce(function (object, key) {
    return Object.defineProperty(object, key, choices[key]);
  }, {});
};
var _default = exports.default = useConditionalChoices;